// src/components/SimpleNavHeader.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/SimpleNavHeader.css';

const SimpleNavHeader = ({
  header_text,
  subtitle,
  onBack,
  rightActions,
  sticky = true,
  transparent = false,
  showDivider = true,
  className = '',
}) => {
  const navigate = useNavigate();
  const handleBack = () => (onBack ? onBack() : navigate(-1));

  return (
    <header
      className={[
        'sn-header',
        sticky ? 'sn-sticky' : '',
        transparent ? 'sn-transparent' : '',
        showDivider ? 'sn-divider' : '',
        className,
      ].join(' ').trim()}
      role="banner"
    >
      {/* Safe area for iOS notches */}
      <div className="sn-safe-top" aria-hidden="true" />

      <div className="sn-inner">
        <button
          onClick={handleBack}
          className="sn-back"
          aria-label="Go back"
          title="Go back"
        >
          <FaArrowLeft />
        </button>

        <div className="sn-title-wrap">
          <h1 className="sn-title" title={header_text}>{header_text}</h1>
          {subtitle && <div className="sn-subtitle" title={subtitle}>{subtitle}</div>}
        </div>

        {/* Optional right-side actions (icons, menu, etc.) */}
        <div className="sn-actions">
          {rightActions}
        </div>
      </div>
    </header>
  );
};

export default SimpleNavHeader;